import { render, staticRenderFns } from "./CurrentUserStatisticsTable.vue?vue&type=template&id=1d8971b6&"
import script from "./CurrentUserStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./CurrentUserStatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports